// official FormikEffect has problems with latest Formik versions
// this is based on the solution by FabianSellmann
// https://github.com/jaredpalmer/formik/issues/766#issuecomment-423468718

import * as React from "react";
import { connect } from "formik";

const Effect = class FormikEffect extends React.Component {
  componentDidUpdate(prevProps) {
    if (prevProps.formik !== this.props.formik) {
      this.props.onChange(prevProps.formik, this.props.formik);
    }
  }

  render() {
    return null;
  }
};

export default connect(Effect);
